import { useLayer } from '@statsig/react-bindings';

import { ExperimentLayers } from '../statsig/experiments';

export const DEFAULT_PRUNE_GRACE_MULTIPLIER = 2;
const VALID_PRUNE_GRACE_MULTIPLIERS = new Set([2, 3, 4]);

export function parsePruneGraceMultiplier(raw: string | number | undefined): number {
  const parsed = typeof raw === 'number' ? raw : parseInt(String(raw ?? ''), 10);
  if (VALID_PRUNE_GRACE_MULTIPLIERS.has(parsed)) return parsed;
  return DEFAULT_PRUNE_GRACE_MULTIPLIER;
}

/**
 * Provider-randomized prune-grace multiplier (2, 3, or 4). `useLayer` logs the
 * exposure on `.get()` and re-renders if Statsig values change.
 */
export function usePruneGraceMultiplier(): number {
  const [layerName, layerConfig] = ExperimentLayers.PruneGraceMultiplier;
  const layer = useLayer(layerName);
  return parsePruneGraceMultiplier(layer.get(layerConfig.pruneGraceMultiplier, DEFAULT_PRUNE_GRACE_MULTIPLIER));
}
